(() => {
	const minWidth = 110;
	const maxWidth = 1200;
	const selector = 'img.img_as';
	const loadedClass = 'img_as--loaded';
	const loadingClass = 'img_as--loading';
	const snapPx = 40;

	const placeholderPrefix = 'data:image/gif;base64,R0lGODlhAQAB';

    	const safeDecode = (img) => {
		if (!img || !img.decode) return Promise.resolve();
		return img.decode().catch(() => {});
	};

	const markLoadedAfterDecode = (img) => {
		return safeDecode(img).then(() => {
			requestAnimationFrame(() => {
				img.classList.add(loadedClass);
				img.classList.remove(loadingClass);
			});
		});
	};

	const preloadSwapWhenAlreadyLoaded = (img, next) => {
		if (!img.classList.contains(loadedClass)) return false;

		const pre = new Image();
		pre.decoding = 'async';
		pre.src = next;

		pre.addEventListener(
			'load',
			() => {
				img.setAttribute('src', next);
			},
			{ once: true }
		);

		pre.addEventListener(
			'error',
			() => {},
			{ once: true }
		);

		return true;
	};

	const pickWidth = (cssPx) => {
		const dpr = Math.min(window.devicePixelRatio || 1, 2);
		const target = Math.ceil(cssPx * dpr);

		let snapped = Math.ceil(target / snapPx) * snapPx;

		if (snapped < minWidth) snapped = minWidth;
		if (snapped > maxWidth) snapped = maxWidth;

		return snapped;
	};

	const buildShopifyCdnUrlFromData = (img, w) => {
		const file = img.getAttribute('data-sov-img-file') || '';
		if (!file) return '';

		const v = img.getAttribute('data-sov-img-v') || '';
		const base = `${location.origin}/cdn/shop/files/${file}`;

		if (v) return `${base}?v=${encodeURIComponent(v)}&width=${w}`;
		return `${base}?width=${w}`;
	};

	const rewriteWidthParam = (url, w) => {
		if (!url) return '';

		if (/[?&]width=\d+/.test(url)) {
			return url.replace(/([?&]width=)\d+/, `$1${w}`);
		}

		const hasQuery = url.indexOf('?') !== -1;
		return `${url}${hasQuery ? '&' : '?'}width=${w}`;
	};

	const applyBestSrc = (img) => {
		const rect = img.getBoundingClientRect();
		if (!rect.width || rect.width < 1) return;

		const chosen = pickWidth(rect.width);

		const current = img.getAttribute('src') || '';
		const isPlaceholder = current.indexOf(placeholderPrefix) === 0;

		let next = '';

		if (isPlaceholder) {
			next = buildShopifyCdnUrlFromData(img, chosen);
		} else {
			next = rewriteWidthParam(current, chosen);
		}

		if (!next || next === current) return;

		if (img.__sov_last_src === next) return;
		img.__sov_last_src = next;

				if (preloadSwapWhenAlreadyLoaded(img, next)) return;

		img.classList.remove(loadedClass);
		img.classList.add(loadingClass);

		img.addEventListener(
			'load',
			() => {
				markLoadedAfterDecode(img);
			},
			{ once: true }
		);

		img.addEventListener(
			'error',
			() => {
				img.classList.remove(loadingClass);
			},
			{ once: true }
		);

		img.setAttribute('src', next);

	};

	const observe = () => {
	const imgs = document.querySelectorAll(selector);

	const hasIO = 'IntersectionObserver' in window;

	const io = hasIO
		? new IntersectionObserver(
				(entries) => {
					entries.forEach((e) => {
						if (e.isIntersecting) applyBestSrc(e.target);
					});
				},
				{
					root: null,
					rootMargin: '600px',
					threshold: 0.01,
				}
		  )
		: null;

	const observeImg = (img) => {
		if (!img) return;
		if (img.__sov_io_observed) return;
		img.__sov_io_observed = 1;

		if (!hasIO) {
			applyBestSrc(img);
			return;
		}

		io.observe(img);
	};

	imgs.forEach(observeImg);

	// intercetta immagini inserite dopo (related products, section rendering, ajax)
	const mo = new MutationObserver((mutations) => {
		mutations.forEach((m) => {
			m.addedNodes.forEach((n) => {
				if (!n || n.nodeType !== 1) return;

				if (n.matches && n.matches(selector)) observeImg(n);

				if (n.querySelectorAll) {
					n.querySelectorAll(selector).forEach(observeImg);
				}
			});
		});
	});

	mo.observe(document.documentElement, { childList: true, subtree: true });

	let raf = 0;
	window.addEventListener(
		'resize',
		() => {
			if (raf) cancelAnimationFrame(raf);
			raf = requestAnimationFrame(() => {
				document.querySelectorAll(selector).forEach(applyBestSrc);
			});
		},
		{ passive: true }
	);
};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observe);
	} else {
		observe();
	}
})();
